export enum SelectInputAction {
  InputChange = 'input-change',
}
